import { render, staticRenderFns } from "./BookingSubtypeUpdate.vue?vue&type=template&id=1d31a60c&"
import script from "./BookingSubtypeUpdate.vue?vue&type=script&lang=js&"
export * from "./BookingSubtypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports